module.exports = __webpack_public_path__ + "img/symbol_10.9ba21089.png";